<template>
    <main :class="{'main':true, 'with-timetable':true, 'locked': locked }">
        <div class="container-fluid">
            <time-table></time-table>
        </div>
    </main>
</template>

<script>
  import TimeTable from '@/components/timetable/TimeTable'

  export default {
    name: 'TablePage',
    components: {TimeTable},
    data () {
      return {
        locked: false
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/pages/Organization/Table/Table.vue